import React, { useState } from 'react';
import LoginModal from './LoginModal';
import RegisterModal from './RegisterModal';

interface AuthManagerProps {
  initialModal?: 'login' | 'register' | null;
  onClose?: () => void;
}

const AuthManager: React.FC<AuthManagerProps> = ({ initialModal = null, onClose }) => {
  const [currentModal, setCurrentModal] = useState<'login' | 'register' | null>(initialModal);

  const handleClose = () => {
    setCurrentModal(null);
    onClose?.();
  };

  const switchToLogin = () => {
    setCurrentModal('login');
  };

  const switchToRegister = () => {
    setCurrentModal('register');
  };

  return (
    <>
      <LoginModal
        open={currentModal === 'login'}
        onClose={handleClose}
        onSwitchToRegister={switchToRegister}
      />
      <RegisterModal
        open={currentModal === 'register'}
        onClose={handleClose}
        onSwitchToLogin={switchToLogin}
      />
    </>
  );
};

// Hook personalizado para manejar modales de autenticación
export const useAuthModal = () => {
  const [modalType, setModalType] = useState<'login' | 'register' | null>(null);

  const openLogin = () => setModalType('login');
  const openRegister = () => setModalType('register');
  const close = () => setModalType(null);

  return {
    modalType,
    openLogin,
    openRegister,
    close,
    AuthModalComponent: () => (
      <AuthManager initialModal={modalType} onClose={close} />
    )
  };
};

export default AuthManager;